import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-stack-fill text-background-50 text-base"></i>
                </div>
                <span className="text-lg font-bold text-background-50 whitespace-nowrap">
                  2048核基地
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                专为2048游戏深度玩家打造的策略攻略与挑战平台，提供最强合并技巧与核心玩法解析。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                攻略分类
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                快速链接
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                    隐私政策
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                    使用条款
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                关注我们
              </h4>
              <p className="text-sm text-background-400 mb-4 leading-relaxed">
                获取最新的2048攻略、技巧和挑战资讯。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line text-background-200 text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line text-background-200 text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors" aria-label="B站">
                  <i className="ri-bilibili-line text-background-200 text-base"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-700">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-background-500">
                &copy; {new Date().getFullYear()} 2048核基地. All rights reserved.
              </p>
              <p className="text-xs text-background-500">
                本网站内容仅供学习交流，非商业用途
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}